<template>
    <VerificationSubsection
        :indentation-level="1"
        title="Address"
    >
        <GoogleMap
            v-if="reportMapLocation.lat && reportMapLocation.lng"
            class="h-72 w-full"
            :map-center="reportMapLocation"
            :markerCoordinates="[reportMapLocation]"
        />
        <VerificationGrid :indentation-level="1">
            <CheckTextualResult
                v-tooltip="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_ADD_INFO_FULLY_FORMATED_ADDRESS)"
                label="Resolved Address:"
                :value="additionalInformation.geolocation.address"
            />
            <CheckTextualResult
                v-tooltip="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_ADD_INFO_RECORD_TYPE)"
                label="Record Type:"
                :value="additionalInformation.geolocation.recordType"
            />
            <CheckTextualResult
                v-tooltip="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_ADD_INFO_COUNTY_FIPS)"
                label="County FIPS:"
                :value="additionalInformation.geolocation.countryFips"
            />
            <CheckTextualResult
                v-tooltip.left="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_ADD_INFO_COUNTY_NAME)"
                label="County Name:"
                :value="additionalInformation.geolocation.country"
            />
            <CheckTextualResult
                v-tooltip.left="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_ADD_INFO_PROPERTY_TYPE)"
                label="Property Type:"
                :value="additionalInformation.geolocation.propertyType"
            />
            <CheckTextualResult
                v-tooltip="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_ADD_INFO_DPV_MATCH)"
                label="DPV Match:"
                :value="additionalInformation.geolocation.dpvMatch"
            />
            <CheckTextualResult
                v-tooltip="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_ADD_INFO_DPV_VACANT)"
                label="DPV Vacant:"
                :value="additionalInformation.geolocation.dpvVacant"
            />
            <CheckTextualResult
                v-tooltip="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_ADD_INFO_ACTIVE)"
                label="Active:"
                :value="additionalInformation.geolocation.active"
            />
        </VerificationGrid>
    </VerificationSubsection>
    <VerificationSubsection
        :helper-text="IDV_HELPER_ADD_INFO_EMAIL_RISK"
        :indentation-level="1"
        title="E-mail risk"
    >
        <VerificationGrid :indentation-level="1">
            <CheckTextualResult
                v-tooltip="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_ADD_INFO_EMAIL_RISK)"
                label="Email:"
                :value="additionalInformation.emailRisk.email"
            />
            <CheckTextualResult
                v-tooltip="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_ADD_INFO_EMAIL_AGE)"
                label="Age:"
                :value="additionalInformation.emailRisk.estimatedAge"
            />
            <CheckTextualResult
                v-tooltip="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_ADD_INFO_EMAIL_REPUTABILITY)"
                label="Reputation:"
                :value="additionalInformation.emailRisk.reputation"
            />
            <CheckTextualResult
                v-tooltip.left="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_ADD_INFO_EMAIL_SUSPICIOUS)"
                label="Suspicious:"
                :value="additionalInformation.emailRisk.suspicious"
            />
            <CheckTextualResult
                v-tooltip.left="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_ADD_INFO_EMAIL_DISPOSABLE)"
                label="Disposable:"
                :value="additionalInformation.emailRisk.disposable"
            />
            <CheckTextualResult
                v-tooltip="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_ADD_INFO_EMAIL_SPAMMY)"
                label="Spam:"
                :value="additionalInformation.emailRisk.spam"
            />
            <CheckTextualResult
                v-tooltip="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_ADD_INFO_EMAIL_DELIVERABLE)"
                label="Deliverable:"
                :value="additionalInformation.emailRisk.deliverable"
            />
            <CheckTextualResult
                v-tooltip="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_ADD_INFO_EMAIL_DOMAIN_AGE)"
                label="Domain Created:"
                :value="additionalInformation.emailRisk.domainAge"
            />
        </VerificationGrid>
    </VerificationSubsection>
    <VerificationSubsection
        :helper-text="IDV_HELPER_ADD_INFO_PHONE_RISK"
        :indentation-level="1"
        title="Phone risk"
    >
        <VerificationGrid :indentation-level="1">
            <CheckTextualResult
                v-tooltip="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_ADD_INFO_PHONE_CLIENT_PHONE_NUMBER)"
                label="Phone Number:"
                :value="additionalInformation.phoneRisk.phoneNumber"
            />
            <CheckTextualResult
                v-tooltip="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_ADD_INFO_PHONE_TYPE)"
                label="Phone Type:"
                :value="additionalInformation.phoneRisk.phoneType"
            />
            <CheckTextualResult
                v-tooltip="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_ADD_INFO_PHONE_ACCOUNT_HOLDER)"
                label="Account Holder:"
                :value="additionalInformation.phoneRisk.accountHolder"
            />
            <CheckTextualResult
                v-tooltip.left="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_ADD_INFO_PHONE_PHONE_CARRIER)"
                label="Phone Carrier:"
                :value="additionalInformation.phoneRisk.carrier"
            />
            <CheckTextualResult
                v-tooltip.left="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_ADD_INFO_PHONE_RISK_LEVEL)"
                label="Risk Level:"
                :value="additionalInformation.phoneRisk.riskLevel"
            />
            <CheckTextualResult
                v-tooltip="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_ADD_INFO_PHONE_RISK_RECOMMENDATION)"
                label="Risk Recommendation:"
                :value="additionalInformation.phoneRisk.riskRecommendation"
            />
            <CheckTextualResult
                v-tooltip="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_ADD_INFO_PHONE_ADDRESS_COMPARISON)"
                label="Address Compariso:"
                :value="additionalInformation.phoneRisk.addressComparison"
            />
            <CheckTextualResult
                v-tooltip="GEN_IDV_STYLED_TOOLTIP(IDV_HELPER_ADD_INFO_PHONE_BIRTHDATE_COMPARISON)"
                label="Birthdate Comparison:"
                :value="additionalInformation.phoneRisk.birthDateComparison"
            />
        </VerificationGrid>
    </VerificationSubsection>
</template>

<script lang="ts" setup>
import type { AdditionalInformationAnalysis } from '@/api/interfaces/identity-verification-report.api';
import { computed } from 'vue';
import GoogleMap from '../../Map/GoogleMap.vue';
import CheckTextualResult from '../common/CheckTextualResult.vue';
import VerificationGrid from '../common/VerificationGrid.vue';
import VerificationSubsection from '../common/VerificationSubsection.vue';
import { GEN_IDV_STYLED_TOOLTIP } from '../common/idv-helper-tooltip.pt';
import {
    IDV_HELPER_ADD_INFO_ACTIVE,
    IDV_HELPER_ADD_INFO_COUNTY_FIPS,
    IDV_HELPER_ADD_INFO_COUNTY_NAME,
    IDV_HELPER_ADD_INFO_DPV_MATCH,
    IDV_HELPER_ADD_INFO_DPV_VACANT,
    IDV_HELPER_ADD_INFO_EMAIL_AGE,
    IDV_HELPER_ADD_INFO_EMAIL_DELIVERABLE,
    IDV_HELPER_ADD_INFO_EMAIL_DISPOSABLE,
    IDV_HELPER_ADD_INFO_EMAIL_DOMAIN_AGE,
    IDV_HELPER_ADD_INFO_EMAIL_REPUTABILITY,
    IDV_HELPER_ADD_INFO_EMAIL_RISK,
    IDV_HELPER_ADD_INFO_EMAIL_SPAMMY,
    IDV_HELPER_ADD_INFO_EMAIL_SUSPICIOUS,
    IDV_HELPER_ADD_INFO_FULLY_FORMATED_ADDRESS,
    IDV_HELPER_ADD_INFO_PHONE_ACCOUNT_HOLDER,
    IDV_HELPER_ADD_INFO_PHONE_ADDRESS_COMPARISON,
    IDV_HELPER_ADD_INFO_PHONE_BIRTHDATE_COMPARISON,
    IDV_HELPER_ADD_INFO_PHONE_CLIENT_PHONE_NUMBER,
    IDV_HELPER_ADD_INFO_PHONE_PHONE_CARRIER,
    IDV_HELPER_ADD_INFO_PHONE_RISK,
    IDV_HELPER_ADD_INFO_PHONE_RISK_LEVEL,
    IDV_HELPER_ADD_INFO_PHONE_RISK_RECOMMENDATION,
    IDV_HELPER_ADD_INFO_PHONE_TYPE,
    IDV_HELPER_ADD_INFO_PROPERTY_TYPE,
    IDV_HELPER_ADD_INFO_RECORD_TYPE,
} from '../idv-static-helper-text';

const props = defineProps<{
    additionalInformation: AdditionalInformationAnalysis;
}>();

const reportMapLocation = computed(() => ({
    lat: props.additionalInformation.geolocation.lat,
    lng: props.additionalInformation.geolocation.lng,
}));
</script>
